import type { QueryParam } from "@ceeferenderer/fe-renderer-sdk";
import { handleResponse } from "./handleResponse";
import { itgExecution } from "./itgExecution";
import { trackPage } from "../utils/trackPage";
import { transform } from "./transform";
import { cimaLogin } from "../utils/cimaLogin";
import { existingCustomer, newCustomer } from "../constants/UIConstants";
import { getWithExpiry } from "../utils/getCimaCallStatus";
import { cimaRedirectTransform } from "./cimaRedirectTransform";
import { backDropDiv } from "../constants/elements";
import { postLoggerEventDetails } from "../utils/nifiLogger";

// eslint-disable-next-line sonarjs/cognitive-complexity
export const process = async (data?: Partial<QueryParam>): Promise<void> => {
  const loadingEl: any = document.getElementById("overlayLoader");
  if (
    data &&
    data?.displayFormReferenceKey &&
    data[data?.displayFormReferenceKey] &&
    data[data?.displayFormReferenceKey].submitButton
  ) {
    sessionStorage.setItem("ev_submitButton", data[data?.displayFormReferenceKey].submitButton);
  } else {
    sessionStorage.setItem("ev_submitButton", "");
  }
  if (sessionStorage.getItem("ev_submitButton") === existingCustomer) {
    postLoggerEventDetails("R360_Anticipated_Visits_UI_CIMA_Launch", "Retail_BusinessTransaction");
    sessionStorage.setItem("userSelected", "customer");
    sessionStorage.setItem("ev_isExistingUserClick", "true");
  }

  if (sessionStorage.getItem("ev_submitButton") === newCustomer) {
    sessionStorage.setItem("userSelected", "guest");
  }
  if (data && data?.displayFormReferenceKey && data[data?.displayFormReferenceKey].submitButton === existingCustomer) {
    localStorage.setItem("displayFormReferenceKey", data?.displayFormReferenceKey);
    localStorage.setItem("sessionId", data?.sessionId);
    localStorage.setItem("stepId", data?.stepId);
    localStorage.setItem("internalCall", "true");
    localStorage.setItem("locPostal", data[data?.displayFormReferenceKey].location_response_postalCode);
    localStorage.setItem("submitButton", data[data?.displayFormReferenceKey].submitButton);
    loadingEl.style.display = "block";
    backDropDiv.style.display = "block";
    await cimaLogin();
  }

  if (data && data?.displayFormReferenceKey && data[data?.displayFormReferenceKey].submitButton !== existingCustomer) {
    if (localStorage.getItem("displayFormReferenceKey")) {
      localStorage.removeItem("displayFormReferenceKey");
    }
    if (localStorage.getItem("sessionId")) {
      localStorage.removeItem("sessionId");
    }
    if (localStorage.getItem("stepId")) {
      localStorage.removeItem("stepId");
    }
    if (localStorage.getItem("internalCall")) {
      localStorage.removeItem("internalCall");
    }
    if (localStorage.getItem("submitButton")) {
      localStorage.removeItem("submitButton");
    }
    if (localStorage.getItem("locPostal")) {
      localStorage.removeItem("locPostal");
    }
  }

  // if (data && data?.displayFormReferenceKey && data[data?.displayFormReferenceKey].reasonNoteValue) {
  //   data[data?.displayFormReferenceKey].reasonNoteValue = data[data?.displayFormReferenceKey].reasonNoteValue.replace(
  //     "<",
  //     "&lt;"
  //   );
  //   data[data?.displayFormReferenceKey].reasonNoteValue = data[data?.displayFormReferenceKey].reasonNoteValue.replace(
  //     ">",
  //     "&gt;"
  //   );
  // }

  const isCimaSuccess = await getWithExpiry();
  if (isCimaSuccess && isCimaSuccess === "true") {
    loadingEl.style.display = "block";
    backDropDiv.style.display = "block";
    const response = await cimaRedirectTransform();
    loadingEl.style.display = "none";
    backDropDiv.style.display = "none";
    handleResponse(response);
    itgExecution.bindEvent();
    window.scrollTo(0, 0);
    trackPage(response.metaData);
  } else {
    loadingEl.style.display = "block";
    backDropDiv.style.display = "block";
    const response = await transform(data);
    loadingEl.style.display = "none";
    backDropDiv.style.display = "none";
    handleResponse(response);
    itgExecution.bindEvent();
    window.scrollTo(0, 0);
    trackPage(response.metaData);
  }

  const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
  const isFirefoxIOS = /FxiOS\/[\d]+/.test(navigator.userAgent);
  if (isChromeIOS || isFirefoxIOS) {
    const calendarElement: any = document.querySelector(".calendar-div");
    if (calendarElement) {
      calendarElement.style.display = "none";
    }
  }

  const notesText: any = document.getElementById("notesTxt");
  if (notesText) {
    notesText.addEventListener("input", () => {
      const remainingCharacters: any = document.getElementById("remainingCharacters");
      if (notesText) {
        const max = 250;
        if (notesText.value.length >= max) {
          notesText.value = notesText.value.substring(0, max);
        }
        remainingCharacters.style.display = "block";
        if (notesText.value.trim().length === 0) {
          remainingCharacters.style.display = "none";
          return;
        }
        if (notesText.value.trim().length === 250) {
          remainingCharacters.innerHTML = "0" + " characters remaining";
        } else {
          remainingCharacters.innerHTML = 250 - notesText.value.trim().length + " characters remaining";
        }
      }
    });
  }

  if (sessionStorage.getItem("cimaSuccessful")) {
    sessionStorage.removeItem("cimaSuccessful");
  }
  if (sessionStorage.getItem("cimaValid")) {
    sessionStorage.removeItem("cimaValid");
  }
};
